import React from 'react';
import { ISuccessState } from '../../interfaces/successState';
import AlertModal from '../alertModal/alertModal';

interface IProps {
  isSuccess: ISuccessState | undefined;
  setIsSuccess: React.Dispatch<React.SetStateAction<ISuccessState | undefined>>;
}

const StatusAlertModel = (props: IProps) => {
  const { isSuccess, setIsSuccess } = props;
  return (
    <AlertModal
      show={!!isSuccess}
      buttons={[
        {
          variant: isSuccess?.isSuccess ? 'success' : 'danger',
          text: 'OK',
          onClick: () => {
            setIsSuccess(undefined);
          },
        },
      ]}
      variant={isSuccess?.isSuccess ? 'success' : 'error'}
    >
      {isSuccess?.message}
    </AlertModal>
  );
};

export default StatusAlertModel;
